<template>
  <main-layout
    class="quality"
    page-title="质量快检结果"
    @listen-back="goBack"
    customBack
  >
    <div slot="main-content" class="main-content" v-loading="loading">
      <!-- 筛选部分 -->
      <div class="list-select">
        <el-row :gutter="20">
          <el-col :span="5" :offset="0">
            <el-select
              v-model="inspectionItem"
              placeholder="请选择检测项目"
              size="medium"
              clearable
              @change="selectList"
            >
              <el-option
                v-for="item in itemOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option> </el-select
          ></el-col>
          <el-col :span="5" :offset="0">
            <el-select
              v-model="resultOption"
              placeholder="请选择检测结论"
              size="medium"
              clearable
              @change="selectList"
            >
              <el-option
                v-for="item in resultOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="5" :offset="0">
            <el-input
              style="width: 222px"
              @change="selectList"
              placeholder="检测明细编号"
              v-model="detailNo"
              clearable
              size="medium"
              icon="el-icon-search"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-col>
          <el-col :span="5" :offset="0">
            <el-input
              style="width: 222px"
              @change="selectList"
              placeholder="食品检测编号"
              v-model="foodNo"
              clearable
              size="medium"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-col>
          <el-col :span="4" :offset="0">
            <el-button type="primary" size="medium" @click="showInfoBind"
              >信息绑定</el-button
            >
          </el-col>
        </el-row>
        <!-- 分割线 -->
        <el-divider></el-divider>
      </div>
      <!-- 列表部分 -->
      <table-list
        ref="tabList"
        class="table-list"
        :isShow="apiData"
        :list="resultList"
        :loading="loading"
      />
      <!-- 分页 -->
      <!-- <pagiation
        :total="total"
        :pageSize="pageSize"
        :pageNo="pageNo"
        @currentChange="currentChange"
        :pagisShow="apiData"
        v-show="apiData"
      /> -->
      <div>
        <el-dialog
          title="质量快检信息绑定"
          :visible.sync="showInfoDialog"
          width="50%"
          :before-close="handleClose"
        >
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-form-item label="被检主体名称" prop="subjectName">
              <el-input
                v-model.trim="ruleForm.subjectName"
                placeholder="请输入"
                maxlength="100"
              ></el-input>
            </el-form-item>
            <el-form-item label="被检主体编号" prop="subjectCode">
              <el-input
                v-model.trim="ruleForm.subjectCode"
                placeholder="请输入"
                maxlength="60"
              ></el-input>
            </el-form-item>

            <el-form-item label="被检人姓名" prop="personName">
              <el-input
                v-model.trim="ruleForm.personName"
                maxlength="20"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="被检人身份证号" prop="personCode">
              <el-input
                v-model.trim="ruleForm.personCode"
                maxlength="40"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="submitInfo">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </main-layout>
</template>

<script>
import TableList from "./tabList.vue";
import MainLayout from "@/layout/MainLayout";
// import Pagiation from "@/components/Pagiation.vue";
import { qualityInspection } from "@/api/request/snkd.produce";
import { mapState, mapActions } from "vuex";

export default {
  name: "InsuranceList",
  components: { MainLayout, TableList },
  data() {
    return {
      inspectionItem: "全部检测项目",
      resultOption: -1,
      detailNo: "",
      foodNo: "",
      total: 20,
      pageSize: 10,
      pageNo: 1,
      apiData: true,
      loading: false,
      showInfoDialog: false,
      lastInfoFlag: false,
      itemOptions: [],
      resultOptions: [
        { id: -1, name: "全部检测结论" },
        { id: 1, name: "合格" },
        { id: 2, name: "不合格" },
      ],
      resultList: [],
      ruleForm: {
        subjectName: "",
        subjectCode: "",
        personCode: "",
        personName: "",
      },
    };
  },
  computed: {
    ...mapState(["companyId", "farmId"]),
  },

  async created() {
    await this.getProjectList();
    await this.getList();
  },
  mounted() {},
  methods: {
    ...mapActions("permission", ["hasPermission"]),
    //筛选
    selectList() {
      // this.pageNo = 1;
      this.getList();
    },
    //获取信息绑定
    async showInfoBind() {
      const { respCode, obj } = await qualityInspection.getBindServe({
        companyId: this.companyId,
      });
      if (respCode == 0) {
        this.ruleForm = { ...obj };
        if (obj) {
          this.lastInfoFlag = true;
        }
        this.showInfoDialog = true;
      }
    },
    //信息绑定弹框-确定
    async submitInfo() {
      if (!this.lastInfoFlag) {
        //新增
        const params = {
          thirdCompanyId: this.$route.query.id,
          id: "",
          companyId: this.companyId,
          personCode: this.ruleForm.personCode,
          personName: this.ruleForm.personName,
          subjectCode: this.ruleForm.subjectCode,
          subjectName: this.ruleForm.subjectName,
        };
        const res = await qualityInspection.getAddBindServe(params);
        const { respCode } = res;
        if (respCode === 0) {
          this.$refs.ruleForm.resetFields();
          this.$message.success("信息绑定成功");
          this.getList();
        } else {
          this.$message.error("信息绑定失败");
        }
      } else {
        //修改
        const param = {
          thirdCompanyId: this.$route.query.id,
          id: this.ruleForm.id,
          companyId: this.companyId,
          personCode: this.ruleForm.personCode,
          personName: this.ruleForm.personName,
          subjectCode: this.ruleForm.subjectCode,
          subjectName: this.ruleForm.subjectName,
        };
        const res = await qualityInspection.getEditBindServe(param);
        const { respCode } = res;
        if (respCode === 0) {
          this.$refs.ruleForm.resetFields();
          this.$message.success("编辑成功");
          this.getList();
        } else {
          this.$message.error("编辑失败");
        }
      }
      this.showInfoDialog = false;
    },
    //
    handleClose() {
      this.showInfoDialog = false;
    },
    //跳转
    async goToDetail() {
      this.$router.push("/quality-result-list");
    },
    //获取项目下拉
    async getProjectList() {
      const { respCode, obj } = await qualityInspection.getProjectItemServe({
        thirdCompanyId: this.$route.query.id,
        companyId: this.companyId,
      });
      if (respCode === 0) {
        this.itemOptions = obj;
      }
    },
    //获取列表数据
    async getList() {
      this.loading = true;
      const { respCode, obj } =
        await qualityInspection.getQualityResultListServe({
          thirdCompanyId: Number(this.$route.query.id),
          companyId: this.companyId,
          itemVerdictId: this.resultOption == -1 ? "" : this.resultOption,
          checkProject:
            this.inspectionItem == "全部检测项目" ? "" : this.inspectionItem,
          foodCheckItemId: this.detailNo,
          foodCheckId: this.foodNo,
        });
      if (respCode === 0) {
        this.resultList = obj;
        this.apiData = !!this.resultList.length;
        this.loading = false;
      }
    },
    //页码切换
    currentChange(pageNo) {
      this.pageNo = pageNo;
      this.getList();
    },
    // 返回上一级跳转到列表页
    goBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.quality {
  .main-content {
    width: 1200px;
    min-height: 100%;
    background: #fff;
    margin: 0 auto;
    padding: 30px 30px 30px;
    box-sizing: border-box;
  }
}

::v-deep .el-dialog__header .el-dialog__title {
  color: #fff !important;
  background-color: #64c3a4;
}
::v-deep .el-dialog__header {
  background-color: #64c3a4;
  text-align: center;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
</style>
